import React from 'react';
import Header from '../components/Header';
import Services from '../components/Services';
import WhoIWorkWith from '../components/WhoIWorkWith';
import HowIWork from '../components/HowIWork';
import Footer from '../components/Footer';
import SeoHead from '../components/SeoHead';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <SeoHead
        title="Services & Expertise – Carol Mezher | Film, Media & Live Events"
        description="Creative direction, film & TV development, festival programming, and large-scale event production. Delivering projects with strategic narrative across film, media, culture and live experiences."
        path="/services"
        ogType="website"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-midnight-blue">
        <div className="container mx-auto px-8 md:px-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center">
              <h1 className="font-playfair font-bold text-5xl md:text-6xl text-white mb-6">
                Services & Expertise
              </h1>
              <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed text-center" style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
                From concept to audience, delivering projects with strategic narrative and {'\n'}creative execution across film, media, culture, and live experiences
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <Services />
      
      {/* Who I Work With */}
      <WhoIWorkWith />
      
      {/* How I Work */}
      <HowIWork />
      
      <Footer />
    </div>
  );
};

export default ServicesPage;
